<template>
  <div class="p-question-list">
    <!-- Question navs. -->
    <nav class="nav">
      <div
        :class="{ active: selectType === 'new' }"
        @click="navRouterLinkBuilder('new')"
      >
        {{ $t("newest") }}
      </div>
      <div
        :class="{ active: selectType === 'invite' }"
        @click="navRouterLinkBuilder('invite')"
      >
        {{ $t("invite") }}
      </div>
      <div
        :class="{ active: selectType === 'excellent' }"
        @click="navRouterLinkBuilder('excellent')"
      >
        {{ $t("question.excellent.name") }}
      </div>
      <div
        :class="{ active: selectType === 'hot' }"
        @click="navRouterLinkBuilder('hot')"
      >
        {{ $t("hot") }}
      </div>
    </nav>

    <!-- Question main. -->

    <main id="main" class="main">
      <!-- <div class="types">
        <div
          v-for="item in types"
          :key="item.id"
          :class="{ active: currentType === item.id }"
          @click="showTypeDetail(item)"
        >
          {{ item.name }}
        </div>
      </div> -->
      <JoLoadMore
        ref="loadmore"
        @onRefresh="onRefresh"
        @onLoadMore="fetchQuestionsMore"
      >
        <!-- <div
          style="padding: 0 30px;backgroundColor:#fff"
          v-if="selectType === 'invite'"
        >
          <template v-for="question in questions">
            <AnswerCard
              :question="question"
              :key="question.id"
              type="invite"
              class="answer-card"
            />
          </template>
        </div> -->
        <div>
          <QuestionCard
            v-for="question in questions"
            :key="question.id"
            :question="question"
          />
        </div>

        <!-- <div
          v-if="bottomStatus > 0"
          :class="`jo-loadmore-foot status-${bottomStatus}`"
          @click="fetchQuestionsMore"
        >
          <slot name="foot">
            <CircleLoading v-if="bottomStatus === 1" />
            <span>{{ bottomTxt }}</span>
          </slot>
        </div> -->
      </JoLoadMore>
    </main>

    <!-- <button class="create-question" @click="$router.push({ name:'PostQuestion' })">
      <svg class="m-style-svg m-svg-small">
        <use xlink:href="#icon-plus" />
      </svg>
    </button> -->
    <FootGuide />
  </div>
</template>

<script>
import LinearLoading from "@/icons/LinearLoading.vue";
import QuestionCard from "./components/QuestionCard.vue";
import { list, getQuestionsTopic } from "@/api/question/questions";
import AnswerCard from "@/components/AnswerCard.vue";

export default {
  name: "QuestionList",
  components: {
    QuestionCard,
    AnswerCard
    // IconLoading: LinearLoading,
  },
  data() {
    return {
      questions: [],
      loading: false,
      loadmore: false,
      types: [],
      currentType: "",
      noMore: false,
      bottomTxt: this.$t("loadmore.bottom[2]"),
      selectType: this.$route.query.type || "new"
    };
  },
  computed: {
    type() {
      const { type = "new" } = this.$route.query;
      return type;
    },
    bottomStatus() {
      return this.loading ? 0 : this.noMore ? 2 : 3;
    }
  },
  watch: {
    bottomStatus(val) {
      const text = this.$t("loadmore.bottom"); // ['加载中...', '-- 没有更多 --', '点击加载更多']
      this.bottomTxt = ["", ...text][val];
    }
  },
  mounted() {
    this.fetchQuestions();
    this.getTopics();
  },
  watch: {
    type() {
      this.selectType = this.$route.query.type || "new";
      this.$refs.loadmore.beforeRefresh();
    }
  },
  methods: {
    /**
     * Nav router link builder.
     *
     * @param {string} type
     * @return {Object}
     * @author Seven Du <shiweidu@outlook.com>
     */
    navRouterLinkBuilder(type) {
      this.selectType = type;
      // this.fetchQuestions()
      this.$refs.loadmore.beforeRefresh();
    },

    /**
     * Fetch question method.
     *
     * @return {void}
     * @author Seven Du <shiweidu@outlook.com>
     */
    fetchQuestions() {
      this.loading = true;
      this.noMore = false;
      this.questions = [];
      list(this.selectType, this.currentType)
        .then(({ data }) => {
          if (!data.length || data.length < 15) {
            this.noMore = true;
          }
          this.questions = data;
          this.loading = false;
          this.$refs.loadmore.afterRefresh(!data.length || data.length < 15);
        })
        .catch(({ response: { data } = {} }) => {
          this.loading = false;
          this.$refs.loadmore.afterRefresh(true);
        });
    },

    fetchQuestionsMore() {
      this.loadmore = true;
      this.loading = true;
      list(this.selectType, this.currentType, this.questions.length + 1)
        .then(({ data }) => {
          this.loadmore = false;
          this.loading = false;
          if (!data.length || data.length < 15) {
            this.noMore = true;
          }
          this.questions = [...this.questions, ...data];
          this.$refs.loadmore.afterLoadMore(!data.length || data.length < 15);
        })
        .catch(({ response: { data } = {} }) => {
          this.loadmore = false;
          this.$refs.loadmore.afterLoadMore(true);
        });
    },
    showTypeDetail(item) {
      // const { currentType } = this
      // const { id } = item
      // this.currentType = currentType === id ? '' : item.id
      // this.fetchQuestions()
      this.$router.push({
        path: `question-topics/${item.id}`
      });
    },
    getTopics() {
      getQuestionsTopic().then(res => {
        this.types = res.data;
      });
    },
    onRefresh() {
      this.fetchQuestions();
    }
  }
};
</script>

<style lang="less" scoped>
.p-question-list {
  padding-top: 150px;
  padding-bottom: 100px;
  min-height: 100vh;

  .nav {
    position: fixed;
    top: 88px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    max-width: 768px;
    height: 70px;
    background: #fff;
    color: #999;
    font-size: 30px;
    border-bottom: solid 1px #dedede; /* no */
    z-index: 10;
    font-weight: bold;
    padding-top: 5px;

    > div {
      color: #999;
      height: 65px;
      line-height: 65px;
    }

    .active {
      color: #333;
      border-bottom: 4px solid @tool-bar-bg;
    }
  }

  .main {
    .main-loading {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 24px;

      &_icon {
        width: 120px;
        height: 30px;
        fill: #58b6d7;
      }
    }
    .main-loadmore {
      margin: 24px auto;
      text-align: center;

      &_button {
        padding: 12px 24px;
        color: #58b6d7;
        background-color: transparent;
        border: solid 1px #58b6d7; /* no */
        border-radius: 6px;
        outline: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

        &.active {
          color: #aaa;
          border: none;
        }
      }
    }
  }

  .create-question {
    position: fixed;
    bottom: 40px;
    right: 40px;
    height: 60px;
    width: 60px;
    padding: 0;
    border-radius: 100%;
    background-color: @primary;
    border: 2px solid #fff; /* no */
    box-shadow: 0px 0px 12px 0px rgba(89, 182, 215, 0.43);
    z-index: 1;

    > svg {
      display: block;
      margin: auto;
      color: #fff;
    }
  }
  .types {
    padding: 45px 33px 27px;
    background-color: #fff;
    overflow-y: auto;
    white-space: nowrap;
    font-size: 24px;
    z-index: 1;
    position: relative;
    > div {
      display: inline-block;
      padding: 10px 22px;
      background-color: #f5f5f5;
      color: #666;
      margin: 0 10px;
      border-radius: 8px;
      &.active {
        color: #fff;
        background-color: #00aeef;
      }
    }
  }
  .answer-card {
    padding: 36px 0;
    background-color: #fff;
    border-bottom: 1px solid #dbdbdb;
  }
}
.jo-loadmore-foot {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.28rem;
  margin-top: 20px;
  &.status-2 {
    color: #ccc;
  }
}

.jo-loadmore-main {
  background-color: inherit;
}
</style>
